export default "__VITE_ASSET__BYR9Kc2k__"